import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
window.React = React;
import './index.scss';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import Home from 'pages/Home';
import PageNotFound from 'pages/PageNotFound';
import LogoutPage from 'pages/LogoutPage';
import routes from 'lib/routes';
import PageBlockLayer from 'components/layouts/PageBlockLayer';
import PageLoading from 'components/PageLoading';
import handshakePromise from 'components/ApiHandshake';
import RoutChangeListener from 'components/RoutChangeListener';
import useGlobalImperativeScripts from 'hooks/useGlobalImperativeScripts';
import { sentryStart } from 'lib/sentry';
const About = React.lazy(() => import('pages/About'));
const Onboarding = React.lazy(() => import('pages/Onboarding'));
const Setup = React.lazy(() => import('pages/Setup'));
const ChooseContainer = React.lazy(() => import('pages/Setup/ChooseContainer'));
const OnboardingSuccess = React.lazy(() => import('pages/Onboarding/SuccessPage'));
const Login = React.lazy(() => import('pages/Login'));
const ForgotPassword = React.lazy(() => import('pages/ForgotPassword'));
const GenericMessage = React.lazy(() => import('pages/GenericMessage'));
const Dashboard = React.lazy(() => import('pages/Dashboard'));
const ChangePassword = React.lazy(() => import('pages/ChangePassword'));
const PlanContainer = React.lazy(() => import('pages/PlanContainer'));
const ServerError = React.lazy(() => import('pages/ServerErrorPage'));
const webMaintenance = React.lazy(() => import('pages/WebMaintenancePage'));
const ProductPage = React.lazy(() => import('pages/ProductPage'));
const ProductSecureCheckout = React.lazy(() => import('pages/ProductPage/ProductSecureCheckout'));
const ProductCheckoutSuccess = React.lazy(() => import('pages/ProductPage/ProductSecureCheckout/SuccessPage'));
const AdobeDownloadInstructions = React.lazy(() => import('pages/AdobeDownloadInstructions'));
const ReadiumDownloadInstructions = React.lazy(() => import('pages/ReadiumDownloadInstructions'));
const PreviewDownloadInstructions = React.lazy(() => import('pages/Dashboard/SettingsContainer/DownloadPageSettings/PreviewDownloadInstructions'));
const ApiHandshake = handshakePromise;

sentryStart();

const App = () => {
    useGlobalImperativeScripts();
    return (
        <Suspense fallback={<PageLoading />}>
            <ApiHandshake>
                <PageBlockLayer>
                    <BrowserRouter>
                        <RoutChangeListener>
                            <Switch>
                                <Route path={routes.serverError} component={ServerError} exact />
                                <Route path={routes.webMaintenance} component={webMaintenance} exact />
                                <Route path={routes.home} component={Home} exact />
                                <Route path={routes.login} component={Login} exact />
                                <Route path={routes.aboutUs} component={About} exact />
                                <Route path={routes.onboarding} component={Onboarding} exact />
                                <Route path={routes.setup} component={Setup} exact />
                                <Route path={routes.choose} component={ChooseContainer} exact />
                                <Route path={routes.plans} component={PlanContainer} exact />
                                <Route path={`${routes.dashboard}/:subpage?`} component={Dashboard} />
                                <Route path={routes.forgotPassword} component={ForgotPassword} exact />
                                <Route path={`${routes.changePassword}/:token`} component={ChangePassword} exact />
                                <Route path={routes.onboardingSuccess} component={OnboardingSuccess} exact />
                                <Route path={routes.systemMessage} component={GenericMessage} exact />
                                <Route path={`${routes.adobeDownloadInstructions}/:transactionId?`} component={AdobeDownloadInstructions} exact />
                                <Route path={`${routes.readiumDownloadInstructions}/:transactionId?`} component={ReadiumDownloadInstructions} exact />
                                <Route path={ routes.previewDownloadInstructions } component={ PreviewDownloadInstructions } exact />
                                <Route path={routes.logout} component={LogoutPage} exact />
                                <Route path={`${routes.productPage}/:merchant/:ebooktitle`} component={ProductPage} exact />
                                <Route path={routes.productSecureCheckout} component={ProductSecureCheckout} exact />
                                <Route path={routes.productCheckoutSuccess} component={ProductCheckoutSuccess} exact />
                                <Redirect from="/account/register" to={routes.onboarding} />
                                <Route component={PageNotFound} />
                            </Switch>
                        </RoutChangeListener>
                    </BrowserRouter>
                </PageBlockLayer>
            </ApiHandshake>
        </Suspense>
    );
};
ReactDOM.render(<App />, document.getElementById('root'));


